export const MARGIN_XXS = '2px';
export const MARGIN_XS = '6px';
export const MARGIN_SM = '12px';
export const MARGIN_MD = '24px';
export const MARGIN_LG = '36px';
export const MARGIN_XL = '48px';
export const MARGIN_XXL = '72px';
export const MARGIN_3XL = '96px';
export const MARGIN_4XL = '120px';
